export const isValidDomain = (email: string): boolean => {
    const regex = /^(https?:\/\/)?((localhost:\d{1,5})|([a-z0-9]+([-a-z0-9]*[a-z0-9]+)?([.]{1}[a-z0-9]+([-a-z0-9]*[a-z0-9]+)*)*\.[a-z]{2,}))(\/.*)?$/i;

    return regex.test(email);
};
